import { getUserId } from '../utils/user';

const userId = getUserId();
export const RETURN_PATH = `/customer/returns/v1`;
export const OMS_PATH = '/oms/customer/order/v1';
// RETURN SERVICE PATHS
export const RETURN_SERVICE_ELIGIBILITY = `${RETURN_PATH}/checkEligibility`;

export const PRINT_RETURN_SHIPPING_LABEL_PATH = `${RETURN_PATH}/user/${userId}/print/returnshippinglabel`;

export const POLICY_VALIDATOR = `${RETURN_PATH}/user/${userId}/ssrhrtvpolicyvalidator`;
export const REFUND_ESTIMATION = `${OMS_PATH}/refund/estimation`;
export const SS_RETURN_CREATE = `${RETURN_PATH}/user/${userId}/ssrreturncreate`;
export const FINALIZE_SORIS_RETURN = `${RETURN_PATH}/createsoris`;
export const VALIDATE_ADDRESS = `${RETURN_PATH}/validate/address`;
export const VALIDATE_ZIPCODE = `${RETURN_PATH}/validate/zipCode`;
export const ORDER_VERSION = `${RETURN_PATH}/order/orderinfo`;
export const APRISS_FINALIZE = `${RETURN_PATH}/finalize`;
